module.exports={render:function (){with(this) {
  return _h('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": message
    },
    on: {
      "change": inputting,
      "input": inputting
    }
  })
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3eee30e8!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-flatpickr/vue-flatpickr-base16.vue
// module id = 68
// module chunks = 2